import React from 'react';

import {StepEditGenericChoicesField} from '../generic-choices-fields';

import type {StepEditFieldProps} from '../commonprops';

export function StepEditCheckboxField(props: StepEditFieldProps): JSX.Element {
  return <StepEditGenericChoicesField {...props} inputType="checkbox" />;
}
